import { Box, SxProps } from '@mui/material';
import { FC } from 'react';

import { observer } from 'mobx-react-lite';

interface Props {
  children: React.ReactNode;
  sxProps?: SxProps;
}

const CenterBox: FC<Props> = observer(props => {
  const { children, sxProps } = props;

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        justifyItems: 'center',
        alignItems: 'center',
        ...sxProps,
      }}
    >
      {children}
    </Box>
  );
});

export default CenterBox;
